import React, { useContext, useEffect } from "react";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import PaymentSecurity from "../pages/payment-security/PaymentSecurity";
import DebtQuery from "../pages/debt-query/DebtQuery";
import SelectedDebts from "../pages/selected-debts/SelectedDebts";
import MakePayment from "../pages/make-payment/MakePayment";
import PaymentResult from "../pages/payment-results/PaymentResult";
import { ToastContainer } from "react-toastify";
import Anasayfa from "../pages/OB/Anasayfa";
import EmlakBasvuru from "../pages/OB/Basvurular/EmlakBasvuru";
import CopToplamaSaatleri from "../pages/OB/Bilgilendirmeler/CopToplamaSaatleri";
import GeriDonusumToplamaSaatleri from "../pages/OB/Bilgilendirmeler/GeriDonusumToplamaSaatleri";
import MeclisKararlari from "../pages/OB/Bilgilendirmeler/MeclisKararlari";
import EncumenKararlari from "../pages/OB/Bilgilendirmeler/EncumenKararlari";
import CevreTemizlikTarifeleri from "../pages/OB/Tarifeler/CevreTemizlikTarifeleri";
import IlanReklamVergisiTarifeleri from "../pages/OB/Tarifeler/IlanReklamVergisiTarifeleri";
import Login from "../pages/OB/Login";
import KatiAtikTarifeleri from "../pages/OB/Tarifeler/KatiAtikTarifeleri";
import EglenceVergisitarifeleri from "../pages/OB/Tarifeler/EglenceVergisiTarifeleri";
import AnasayfaAraMenu from "../pages/OB/AnasayfaAraMenu";
import EmlakVergisiTarifeleri from "../pages/OB/Tarifeler/EmlakVergisiTarifeleri";
import IstekSikayet from "../pages/OB/Basvurular/Istek-Sikayet-main";
import BeyanlarBildirimler from "../pages/OB/KayitliBilgilerim/beyanlar-bildirimler/BeyanlarBildirimler";
import OdemeEmirleri from "../pages/OB/KayitliBilgilerim/odeme-emri/OdemeEmirleri";
import HacizVarakalari from "../pages/OB/KayitliBilgilerim/haciz-varakasi/HacizVarakasi";
import OdemeBilgileri from "../pages/OB/OnlineOdemeler/OdemeBilgileri";
import KatiAtikBasvuru from "../pages/OB/Basvurular/kati-atik-basvuru";
import IlanReklamBasvuru from "../pages/OB/Basvurular/ilan-reklam-basvuru";
import KayitOl from "../pages/OB/kayit-ol";
import IsYeriRuhsatBasvuru from "../pages/OB/Basvurular/isyeri-ruhsat-basvuru";
import EglenceBasvuru from "../pages/OB/Basvurular/eglence-vergisi";
import StajBursBase from "../pages/OB/Basvurular/Staj-Burs-base";
import EhgtBasvuru from "../pages/OB/Basvurular/elektrik-hava-gaz-basvuru";
import SuAboneEndeksKarti from "../pages/OB/EAbonelik/SuAboneEndeksKarti";
import YeniAbonelik from "../pages/OB/EAbonelik/YeniAbonelik";
import ComboBox from "../pages/OB/EAbonelik/deneme";
import ProjeOnerileri from "../pages/OB/proje-onerileri";

import NobetciEczaneler from "../pages/OB/Bilgilendirmeler/NobetciEczaneler";
import EBordro from "../pages/OB/EBordro/EBordro";
import BankaBilgileri from "../pages/OB/admin/BankaBilgileri";
import AbonelikIptalSozlesmeIptal from "../pages/OB/EAbonelik/abonelik-sozlesme-iptal";
import ArizaBasvuru from "../pages/OB/EAbonelik/ariza-basvuru";
import FaturaItiraz from "../pages/OB/EAbonelik/fatura-itiraz";
import AbonelikDevirBasvurusu from "../pages/OB/EAbonelik/abonelik-devir-basvuru";
import KacakSuIhbar from "../pages/OB/EAbonelik/kacak-su-ihbar";
import Anketlerim from "../pages/OB/anketler/Anketlerim";
import Anket from "../pages/OB/anketler/Anket";
import AdminMenuControl from "../pages/OB/admin/admin-menu-control";
import SicilBilgileri from "../pages/sicil-bilgileri";
import Basvurularim from "../pages/OB/Basvurular/Basvurularim";
import NotFound from "./notfound";
import SessionStorageService from "../services/StorageService";

import EndeksBildirim from "../pages/OB/EAbonelik/endeks-bildirim";
import OAuthTRCallbackPage from "../pages/OB/oauthtrcallbackpage";
import { ConstantAPISContext } from "../context/ConstantAPISContext";
import { Profile } from "../pages/OB/profil/Profil";
import UyelikUpdate from "../pages/OB/admin/KullaniciYonetim";
import WebSabitlerGuncelle from "../pages/OB/admin/WebSabitlerGuncelle";
import GuvenlikMetni from "../pages/OB/GuvenlikMetni/GuvenlikMetni";
import YanginSigortaVergisiBasvuru from "../pages/OB/Basvurular/yangin-sigorta-vergisi-basvuru";
import SicilArama from "../pages/OB/SicilArama/SicilArama";
import AboneNumarasiSorgulama from "../pages/OB/AboneNumarasiSorgulama/AboneNumarasiSorgulama";
import EKutuphaneTakip from "../pages/OB/KutuphaneIslemleri/EKutuphaneTakip";
import KutuphaneKatalog from "../pages/OB/KutuphaneIslemleri/KutuphaneKatalog";
import SosyalYardimBasvurusu from "../pages/OB/Basvurular/sosyal-yardim-basvurusu";
import DigerOnlineBasvurular from "../pages/OB/Basvurular/diger-online-basvurular";
import Duyurular from "../pages/OB/admin/duyurular";
import YapilandirmaIslemleri from "../pages/OB/OnlineIslemler/yapilandirma-islemleri";
import EvlendirmeBasvurusu from "../pages/OB/Basvurular/evlendirme-basvurusu";
import SifreYenile from "../pages/OB/SifreYenile";
import IkIslemleri from "../pages/OB/Personelslemleri/IkIslemleri";
import IzinBasvuru from "../pages/OB/Personelslemleri/IzinBasvuru";
import IzinTalepIslem from "../pages/OB/Personelslemleri/IzinTalepIslem";


export default function AppRoute(props: any) {
  const location = useLocation();
  const pathname = location.pathname;
  const { menuListAll } = useContext(ConstantAPISContext);

  // Check if current path exists in menuListAll
  // Add this component to handle restricted routes

  useEffect(() => {
    window.scrollTo(0, 0);
    console.log("scroll çalıştı");
  }, [pathname]);

  let user = SessionStorageService.getUserInfo();

  return (
    <>
      <Routes>
        <Route path="/anasayfa" element={<Anasayfa />} />
        <Route path="/" element={<Navigate replace to="/anasayfa" />} />
        <Route path="/oauthtr" element={<OAuthTRCallbackPage />} />

        <Route path="/yapilandirma-islemleri" element={<YapilandirmaIslemleri />} />

        <Route path="/sicil-bilgileri" element={<SicilBilgileri />} />
        <Route
          path="/login"
          element={<Login kullaniciVarmi={props.kullaniciVarmi} />}
        />
        <Route path="/uyelik-kayit" element={<KayitOl />} />
        <Route path="/sifre-yenile" element={<SifreYenile />} />

        {menuListAll
          .map((m) => m.sayfaLink)
          .includes("/anasayfa/online-basvurular") ? (
          <Route
            path="/anasayfa/online-basvurular"
            element={<AnasayfaAraMenu />}
          />
        ) : null}
        {menuListAll
          .map((m) => m.sayfaLink)
          .includes("/anasayfa/e-abonelik-islemleri") ? (
          <Route
            path="/anasayfa/e-abonelik-islemleri"
            element={<AnasayfaAraMenu />}
          />
        ) : null}
        {menuListAll.map((m) => m.sayfaLink).includes("/anasayfa/tarifeler") ? (
          <Route path="/anasayfa/tarifeler" element={<AnasayfaAraMenu />} />
        ) : null}
        {menuListAll
          .map((m) => m.sayfaLink)
          .includes("/anasayfa/kayitli-bilgilerim") ? (
          <Route
            path="/anasayfa/kayitli-bilgilerim"
            element={<AnasayfaAraMenu />}
          />
        ) : null}
        {menuListAll
          .map((m) => m.sayfaLink)
          .includes("/anasayfa/online-odeme") ? (
          <Route path="/anasayfa/online-odeme" element={<AnasayfaAraMenu />} />
        ) : null}
        {menuListAll
          .map((m) => m.sayfaLink)
          .includes("/anasayfa/bilgilendirmeler") ? (
          <Route
            path="/anasayfa/bilgilendirmeler"
            element={<AnasayfaAraMenu />}
          />
        ) : null}
        {menuListAll
          .map((m) => m.sayfaLink)
          .includes("/anasayfa/admin-islemleri") ? (
          user ? (
            user.rol === "ADMIN" ? (
              <Route
                path="/anasayfa/admin-islemleri"
                element={<AnasayfaAraMenu />}
              />
            ) : null
          ) : null
        ) : null}

        {menuListAll
          .map((m) => m.sayfaLink)
          .includes("/admin-islemleri/kullanici-yonetimi") ? (
          user ? (
            user.rol === "ADMIN" ? (
              <Route
                path="/admin-islemleri/kullanici-yonetimi"
                element={<UyelikUpdate />}
              />
            ) : null
          ) : null
        ) : null}
        {menuListAll
          .map((m) => m.sayfaLink)
          .includes("/admin-islemleri/banka-bilgileri-guncelle") ? (
          user ? (
            user.rol === "ADMIN" ? (
              <Route
                path="/admin-islemleri/banka-bilgileri-guncelle"
                element={<BankaBilgileri />}
              />
            ) : null
          ) : null
        ) : null}
        {menuListAll.map((m) => m.sayfaLink).includes("/menu-control") ? (
          user ? (
            user.rol === "ADMIN" ? (
              <Route path="/menu-control" element={<AdminMenuControl />} />
            ) : null
          ) : null
        ) : null}
        {menuListAll
          .map((m) => m.sayfaLink)
          .includes("/admin-islemleri/sabit-bilgileri-guncelle") ? (
          user ? (
            user.rol === "ADMIN" ? (
              <Route
                path="/admin-islemleri/sabit-bilgileri-guncelle"
                element={<WebSabitlerGuncelle />}
              />
            ) : null
          ) : null
        ) : null}
        {menuListAll
          .map((m) => m.sayfaLink)
          .includes("/admin-islemleri/duyurular") ? (
          user ? (
            user.rol === "ADMIN" ? (
              <Route
                path="/admin-islemleri/duyurular"
                element={<Duyurular />}
              />
            ) : null
          ) : null
        ) : null}
        {menuListAll
          .map((m) => m.sayfaLink)
          .includes("/e-abonelik-islemleri/endeks-bildirim") ? (
          <Route
            path="/e-abonelik-islemleri/endeks-bildirim"
            element={<EndeksBildirim />}
          />
        ) : null}
        {menuListAll
          .map((m) => m.sayfaLink)
          .includes("/staj-burs-islemleri") ? (
          <Route path="/staj-burs-islemleri" element={<StajBursBase />} />
        ) : null}
        {menuListAll
          .map((m) => m.sayfaLink)
          .includes("/online-basvurular/elektrik-havagazi-basvurusu") ? (
          <Route
            path="/online-basvurular/elektrik-havagazi-basvurusu"
            element={<EhgtBasvuru />}
          />
        ) : null}
        {menuListAll
          .map((m) => m.sayfaLink)
          .includes("/e-abonelik-islemleri/abonelik-iptal-sozlesme-iptal") ? (
          <Route
            path="/e-abonelik-islemleri/abonelik-iptal-sozlesme-iptal"
            element={<AbonelikIptalSozlesmeIptal />}
          />
        ) : null}
        {menuListAll
          .map((m) => m.sayfaLink)
          .includes("/e-abonelik-islemleri/ariza-basvuru") ? (
          <Route
            path="/e-abonelik-islemleri/ariza-basvuru"
            element={<ArizaBasvuru />}
          />
        ) : null}
        {menuListAll
          .map((m) => m.sayfaLink)
          .includes("/e-abonelik-islemleri/fatura-itiraz") ? (
          <Route
            path="/e-abonelik-islemleri/fatura-itiraz"
            element={<FaturaItiraz />}
          />
        ) : null}
        {menuListAll
          .map((m) => m.sayfaLink)
          .includes("/e-abonelik-islemleri/abonelik-devir-basvurusu") ? (
          <Route
            path="/e-abonelik-islemleri/abonelik-devir-basvurusu"
            element={<AbonelikDevirBasvurusu />}
          />
        ) : null}
        {menuListAll.map((m) => m.sayfaLink).includes("/anketler") ? (
          <Route path="/anketler" element={<Anketlerim />} />
        ) : null}
        {menuListAll.map((m) => m.sayfaLink).includes("/anketler") ? (
          <Route path="/anketler/:konuId" element={<Anket />} />
        ) : null}
        {menuListAll
          .map((m) => m.sayfaLink)
          .includes("/e-abonelik-islemleri/kacak-su-ihbar") ? (
          <Route
            path="/e-abonelik-islemleri/kacak-su-ihbar"
            element={<KacakSuIhbar />}
          />
        ) : null}
        {menuListAll.map((m) => m.sayfaLink).includes("/proje-onerileri") ? (
          <Route path="/proje-onerileri" element={<ProjeOnerileri />} />
        ) : null}
        {menuListAll
          .map((m) => m.sayfaLink)
          .includes("/online-basvurular/isyeri-ruhsat-basvurusu") ? (
          <Route
            path="/online-basvurular/isyeri-ruhsat-basvurusu"
            element={<IsYeriRuhsatBasvuru />}
          />
        ) : null}
        {menuListAll
          .map((m) => m.sayfaLink)
          .includes("/online-basvurular/eglence-vergisi-basvurusu") ? (
          <Route
            path="/online-basvurular/eglence-vergisi-basvurusu"
            element={<EglenceBasvuru />}
          />
        ) : null}
        {menuListAll
          .map((m) => m.sayfaLink)
          .includes("/online-basvurular/nikah-basvurusu") ? (
          <Route
            path="/online-basvurular/nikah-basvurusu"
            element={<EvlendirmeBasvurusu />}
          />
        ) : null}
        {menuListAll
          .map((m) => m.sayfaLink)
          .includes("/online-basvurular/basvurularim") ? (
          <Route
            path="/online-basvurular/basvurularim"
            element={<Basvurularim />}
          />
        ) : null}
        /
        {menuListAll
          .map((m) => m.sayfaLink)
          .includes("/online-basvurular/kati-atik-basvurusu") ? (
          <Route
            path="/online-basvurular/kati-atik-basvurusu"
            element={<KatiAtikBasvuru key="kati-atik" basvuruTuruId={12} />}
          />
        ) : null}

        {menuListAll
          .map((m) => m.sayfaLink)
          .includes("/online-basvurular/cevre-temizlik-basvurusu") ? (
          <Route
            path="/online-basvurular/cevre-temizlik-basvurusu"
            element={<KatiAtikBasvuru key="cevre-temizlik" basvuruTuruId={4} />}
          />
        ) : null}

        {menuListAll
          .map((m) => m.sayfaLink)
          .includes("/online-basvurular/ilan-reklam-basvurusu") ? (
          <Route
            path="/online-basvurular/ilan-reklam-basvurusu"
            element={<IlanReklamBasvuru />}
          />
        ) : null}
        {menuListAll
          .map((m) => m.sayfaLink)
          .includes("/online-basvurular/istek-sikayet-basvurusu") ? (
          <Route
            path="/online-basvurular/istek-sikayet-basvurusu"
            element={<IstekSikayet />}
          />
        ) : null}
        {menuListAll
          .map((m) => m.sayfaLink)
          .includes("/online-basvurular/emlak-bildirim-basvurusu") ? (
          <Route
            path="/online-basvurular/emlak-bildirim-basvurusu"
            element={<EmlakBasvuru />}
          />
        ) : null}
        {menuListAll
          .map((m) => m.sayfaLink)
          .includes("/online-basvurular/yangin-sigorta-vergisi-basvuru") ? (
          <Route
            path="/online-basvurular/yangin-sigorta-vergisi-basvuru"
            element={<YanginSigortaVergisiBasvuru />}
          />
        ) : null}
        {menuListAll
          .map((m) => m.sayfaLink)
          .includes("/online-basvurular/sosyal-yardim-basvurusu") ? (
          <Route
            path="/online-basvurular/sosyal-yardim-basvurusu"
            element={<SosyalYardimBasvurusu />}
          />
        ) : null}
        {menuListAll
          .map((m) => m.sayfaLink)
          .includes("/online-basvurular/diger-online-basvurular") ? (
          <Route
            path="/online-basvurular/diger-online-basvurular"
            element={<DigerOnlineBasvurular />}
          />
        ) : null}

        {menuListAll
          .map((m) => m.sayfaLink)
          .includes("/bilgilendirmeler/cop-toplama-saatleri") ? (
          <Route
            path="/bilgilendirmeler/cop-toplama-saatleri"
            element={<CopToplamaSaatleri />}
          />
        ) : null}
        {menuListAll
          .map((m) => m.sayfaLink)
          .includes("/bilgilendirmeler/geri-donusum-toplama-saatleri") ? (
          <Route
            path="/bilgilendirmeler/geri-donusum-toplama-saatleri"
            element={<GeriDonusumToplamaSaatleri />}
          />
        ) : null}
        {menuListAll
          .map((m) => m.sayfaLink)
          .includes("/bilgilendirmeler/meclis-kararlari") ? (
          <Route
            path="/bilgilendirmeler/meclis-kararlari"
            element={<MeclisKararlari />}
          />
        ) : null}
        {menuListAll
          .map((m) => m.sayfaLink)
          .includes("/bilgilendirmeler/encumen-kararlari") ? (
          <Route
            path="/bilgilendirmeler/encumen-kararlari"
            element={<EncumenKararlari />}
          />
        ) : null}
        {menuListAll
          .map((m) => m.sayfaLink)
          .includes("/bilgilendirmeler/nobetci-eczaneler") ? (
          <Route
            path="/bilgilendirmeler/nobetci-eczaneler"
            element={<NobetciEczaneler />}
          />
        ) : null}
        {menuListAll
          .map((m) => m.sayfaLink)
          .includes("/tarifeler/cevre-temizlik-tarifeleri") ? (
          <Route
            path="/tarifeler/cevre-temizlik-tarifeleri"
            element={<CevreTemizlikTarifeleri />}
          />
        ) : null}
        {menuListAll
          .map((m) => m.sayfaLink)
          .includes("/tarifeler/ilan-reklam-tarifeleri") ? (
          <Route
            path="/tarifeler/ilan-reklam-tarifeleri"
            element={<IlanReklamVergisiTarifeleri />}
          />
        ) : null}
        {menuListAll
          .map((m) => m.sayfaLink)
          .includes("/tarifeler/kati-atik-tarifeleri") ? (
          <Route
            path="/tarifeler/kati-atik-tarifeleri"
            element={<KatiAtikTarifeleri />}
          />
        ) : null}
        {menuListAll
          .map((m) => m.sayfaLink)
          .includes("/tarifeler/eglence-vergisi-tarifeleri") ? (
          <Route
            path="/tarifeler/eglence-vergisi-tarifeleri"
            element={<EglenceVergisitarifeleri />}
          />
        ) : null}
        {menuListAll
          .map((m) => m.sayfaLink)
          .includes("/tarifeler/emlak-vergisi-tarifeleri") ? (
          <Route
            path="/tarifeler/emlak-vergisi-tarifeleri"
            element={<EmlakVergisiTarifeleri />}
          />
        ) : null}
        {menuListAll
          .map((m) => m.sayfaLink)
          .includes("/kayitli-bilgilerim/beyanlar-bildirimler") ? (
          <Route
            path="/kayitli-bilgilerim/beyanlar-bildirimler"
            element={<BeyanlarBildirimler />}
          />
        ) : null}
        {menuListAll
          .map((m) => m.sayfaLink)
          .includes("/kayitli-bilgilerim/odeme-emri") ? (
          <Route
            path="/kayitli-bilgilerim/odeme-emri"
            element={<OdemeEmirleri />}
          />
        ) : null}
        {menuListAll
          .map((m) => m.sayfaLink)
          .includes("/kayitli-bilgilerim/haciz-varakasi") ? (
          <Route
            path="/kayitli-bilgilerim/haciz-varakasi"
            element={<HacizVarakalari />}
          />
        ) : null}
        {menuListAll.map((m) => m.sayfaLink).includes("/odeme-bilgileri") ? (
          <Route path="/odeme-bilgileri" element={<OdemeBilgileri />} />
        ) : null}
        {menuListAll
          .map((m) => m.sayfaLink)
          .includes("/e-abonelik-islemleri/su-abone-endeks-karti") ? (
          <Route
            path="/e-abonelik-islemleri/su-abone-endeks-karti"
            element={<SuAboneEndeksKarti />}
          />
        ) : null}
        {menuListAll
          .map((m) => m.sayfaLink)
          .includes("/e-abonelik-islemleri/yeni-abonelik") ? (
          <Route
            path="/e-abonelik-islemleri/yeni-abonelik"
            element={<YeniAbonelik />}
          />
        ) : null}

        {menuListAll.map((m) => m.sayfaLink).includes("/personel-islemleri/ebordro") ? (
          user ? (
            user.rol === "PERSONEL" || user.rol === "ADMIN" ? (
              <Route path="/personel-islemleri/ebordro" element={<EBordro />} />
            ) : null
          ) : null
        ) : null}
        {
          user != null ? user.sicilGiris ? null : <Route path="/profil-guncelle" element={<Profile />} /> : null

        }

        {menuListAll.map((m) => m.sayfaLink).includes("/guvenlik-metni") ? (
          <Route path="/guvenlik-metni" element={<GuvenlikMetni />} />
        ) : null}

        {menuListAll.map((m) => m.sayfaLink).includes("/sicil-arama") ? (
          <Route path="/sicil-arama" element={<SicilArama />} />
        ) : null}

        {menuListAll
          .map((m) => m.sayfaLink)
          .includes("/e-abonelik-islemleri/abone-no-sorgulama") ? (
          <Route
            path="/e-abonelik-islemleri/abone-no-sorgulama"
            element={<AboneNumarasiSorgulama />}
          />
        ) : null}

        {menuListAll
          .map((m) => m.sayfaLink)
          .includes("/anasayfa/kutuphane-islemleri") ? (
          <Route
            path="/anasayfa/kutuphane-islemleri"
            element={<AnasayfaAraMenu />}
          />
        ) : null}

        {menuListAll
          .map((m) => m.sayfaLink)
          .includes("/kutuphane-islemleri/ekutuphane-takip") ? (
          <Route
            path="/kutuphane-islemleri/ekutuphane-takip"
            element={<EKutuphaneTakip />}
          />
        ) : null}

        {menuListAll
          .map((m) => m.sayfaLink)
          .includes("/kutuphane-islemleri/kutuphane-katalog") ? (
          <Route
            path="/kutuphane-islemleri/kutuphane-katalog"
            element={<KutuphaneKatalog />}
          />
        ) : null}

        {menuListAll
          .map((m) => m.sayfaLink)
          .includes("/anasayfa/personel-islemleri") ? (
          user ? (
            user.rol === "PERSONEL" || user.rol === "ADMIN" ? (
              <Route
                path="/anasayfa/personel-islemleri"
                element={<AnasayfaAraMenu />}
              />
            ) : null
          ) : null
        ) : null}
        

        {menuListAll
          .map((m) => m.sayfaLink)
          .includes("/personel-islemleri/ik-islemleri") ? (
          user ? (
            user.rol === "PERSONEL" || user.rol === "ADMIN" ? (
              <Route
                path="/personel-islemleri/ik-islemleri"
                element={<IkIslemleri />}
              />
            ) : null
          ) : null
        ) : null}

        {menuListAll
          .map((m) => m.sayfaLink)
          .includes("/personel-islemleri/izin-basvuru") ? (
          user ? (
            user.rol === "PERSONEL" || user.rol === "ADMIN" ? (
              <Route
                path="/personel-islemleri/izin-basvuru"
                element={<IzinBasvuru />}
              />
            ) : null
          ) : null
        ) : null}

        {menuListAll
          .map((m) => m.sayfaLink)
          .includes("/personel-islemleri/izin-talep-islem") ? (
          user ? (
            user.rol === "PERSONEL" || user.rol === "ADMIN" ? (
              <Route
                path="/personel-islemleri/izin-talep-islem"
                element={<IzinTalepIslem />}
              />
            ) : null
          ) : null
        ) : null}

        <Route path="*" element={<NotFound />} />
      </Routes>
      <ToastContainer position="top-center" autoClose={10000} />
    </>
  );
}
